import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { PrescriptionTypes } from '@lib/prescriptions/data-access';
import { TranslatePipe } from '@ngx-translate/core';

import { InfoBadgeColors, InfoBadgeComponent } from '@lib/shared-ui/commons/info-badge/info-badge.component';
import { PrescriptionIconComponent } from '../icon/prescription-icon.component';

export interface PrescriptionModalItemData {
  id: string;
  name?: string;
  franchise?: number;
  type: PrescriptionTypes;
}

@Component({
  selector: 'prescriptions-modal-item',
  standalone: true,
  imports: [NgClass, TranslatePipe, PrescriptionIconComponent, InfoBadgeComponent],
  templateUrl: './prescription-modal-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrescriptionModalItemComponent {
  prescription = input.required<PrescriptionModalItemData>();

  protected readonly badgeColors = InfoBadgeColors;
}